import apiOptions from '@/api/public/options';

const defaultState = () => ({
	courier: [],
	ongkir: [],
	provinces: [],
	cities: [],
	subdistricts: [],
	listBank: [],
	bankAccountList: [],
	paymentMethodList: []
});

const state = defaultState();

const getters = {
};

const mutations = {
	setCourier(state, data) {
		state.courier = data
	},
	setOngkir(state, data) {
		state.ongkir = data
	},
	setProvince(state, data) {
		state.provinces = data
	},
	setCity(state, data) {
		state.cities = data
	},
	setSubdistrict(state, data) {
		state.subdistricts = data
	},
	setListBank(state, data) {
		state.listBank = data
	},
	setBanAccountList(state, data) {
		state.bankAccountList = data
	},
	setPaymentMethodList(state, data) {
		state.paymentMethodList = data
	},
	clearOptions(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getCourier({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getCourier(params).then(({ data: { data } }) => {
				commit('setCourier', data.results);
				resolve(true);
			}).catch(() => {
				commit('setCourier', []);
			});
		});
	},
	async getOngkir({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getOngkir(params).then(({ data: { data } }) => {
				commit('setOngkir', data.results);
				resolve(data.results);
			}).catch(() => {
				commit('setOngkir', []);
			});
		});
	},
	async getProvince({ commit }) {
		return new Promise((resolve) => {
			apiOptions.getProvince().then(({ data: { data } }) => {
				commit('setProvince', data.results);
				resolve(true);
			}).catch(() => {
				commit('setProvince', []);
			});
		});
	},
	async getCity({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getCity(params).then(({ data: { data } }) => {
				commit('setCity', data.results);
				resolve(true);
			}).catch(() => {
				commit('setCity', []);
			});
		});
	},
	async getSubdistrict({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getSubdistrict(params).then(({ data: { data } }) => {
				commit('setSubdistrict', data.results);
				resolve(true);
			}).catch(() => {
				commit('setSubdistrict', []);
			});
		});
	},
	async getBankList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getBankList(params).then(({ data: { data } }) => {
				commit('setListBank', data.results);
				resolve(true);
			}).catch(() => {
				commit('setListBank', []);
			});
		});
	},
	async getBankAccountList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getBankAccountList(params).then(({ data: { data } }) => {
				commit('setBanAccountList', data.results);
				resolve(data.results);
			}).catch(() => {
				commit('setBanAccountList', []);
			});
		});
	},
	async getPaymentMethodList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getPaymentMethodList(params).then(({ data: { data } }) => {
				commit('setPaymentMethodList', data.results);
				resolve(true);
			}).catch(() => {
				commit('setPaymentMethodList', []);
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};